import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {connect} from "react-redux";
import {actions} from "../../actions";
import _ from 'lodash';
import ValidationSnackBar from '../parts/ValidationSnackBar';

import ArtifactRow from './ArtifactRow';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    tableContainer: {
        maxHeight: '70vh', // Makes table take up 70% of viewport height
        overflow: 'auto',
    },
    tableHead: {
        position: 'sticky',
        top: 0,
        backgroundColor: theme.palette.background.paper,
        zIndex: 1,
    },
});

class ArtifactPreview extends React.Component  {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            // page: 0,
            // rowsPerPage: 100,
            artifacts: [],
            numArtifacts: 0,
            snackBarOpen: false
        };
        this.toggleSnackBar = this.toggleSnackBar.bind(this);

    };

    componentDidMount(){
        this._isMounted = true;
        if(this.props.changed) {
            this.props.fetchArtifacts(this.props.form)
                .then(() => {
                    if(this.props.artifacts) {
                        if (this._isMounted) {
                            this.setState({artifacts: this.props.artifacts})
                        }
                    }
                })
        } else {
            if (this.props.artifacts.length > 0) {
                if (this._isMounted) {
                    this.setState({artifacts: this.props.artifacts})
                }
            } else {
                this.props.fetchArtifacts(this.props.form)
                    .then(() => {
                        if(this.props.artifacts) {
                            if (this._isMounted) {
                                this.setState({artifacts: this.props.artifacts})
                            }
                        }
                    })
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    renderRows(list) {
        if(list.length > 0) {
            // let slicedList = list.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage);
            // console.log('slicedList from the artifact Preview row render', slicedList);
            return _.map(list, row => {
                if(row){
                    let course = this.props.form.courses.find(x => x.canvas_course_id === row.canvas_course_id);
                    row.course_code = course.course_code;
                    row.name = course.name;
                    return (
                        <ArtifactRow key={row.canvas_submission_id + '-' + row.canvas_user_id} row={row} hideActions={this.props.hideActions} toggleSnackBarCallback={this.toggleSnackBar}/>
                    );
                }
            })
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            snackBarOpen: false
        });
    };

    toggleSnackBar() {
        this.setState({
            snackBarOpen: true
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                <div className={classes.tableContainer}>
                    <Table className={classes.table}>
                        <TableHead className={classes.tableHead}>
                            <TableRow>
                                <TableCell>Course Code</TableCell>
                                <TableCell>Course Name</TableCell>
                                <TableCell>Assignment Name</TableCell>
                                <TableCell>Artifact ID</TableCell>
                                <TableCell>Artifact</TableCell>
                                {this.props.form.checked&&
                                [
                                    <TableCell>Artifact Tier</TableCell>,
                                    <TableCell>Canvas Score</TableCell>
                                ]
                                }
                                {!this.props.hideActions &&
                                    <TableCell>Swap Artifact</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderRows(this.state.artifacts)}
                        </TableBody>
                    </Table>
                </div>
                <ValidationSnackBar variant="error" message={"No more artifacts to swap"} open={this.state.snackBarOpen} onClose={this.handleClose}/>
            </Paper>
        );

    }
}

function mapStateToProps(state) {
    return { form: state.newAssessmentForm, artifacts: state.artifacts };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(ArtifactPreview));
